export default __webpack_public_path__ + "static/media/icon-paid-package.81ab0387.png";